import React from 'react';
import styled from 'styled-components';
import {fontSize, tabletWidth} from '../../mixins';

const StyledSignOut = styled.div`
  width: 450px;
  
  @media screen and (max-width: ${tabletWidth}) {
     width: 290px;
  }
`

const Title = styled.b`
  ${fontSize(24)};
  line-height: 40px;
  font-weight: 600;
  color: #323232;
  mix-blend-mode: normal;
`

const StyledBody = styled.p`
  ${fontSize(14)} !important;
  line-height: 20px !important;
  color: #323232 !important;
  font-weight: 400;
`


const SignOut = () => (
    <StyledSignOut>
        <Title>Sign Out</Title>
        <StyledBody>Are you sure you want to sign out?</StyledBody>
    </StyledSignOut>
);

export default SignOut;